
import 'slick-carousel'

function initSlickSlider() {
  $('.section-carousel .slides').slick({
    slidesToScroll: 1,
    slidesToShow:1,
    arrows: true,
    centerMode:false,
  })

  $('.js-slider-boxes-secondary .slider__slides').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true,
  })

  $('.js-slider-solutions .slider__slides').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
		    {
		      breakpoint: 1400,
		      settings: {
		        slidesToShow: 2,
		      },
		    },
		    {
		      breakpoint: 900,
		      settings: {
		        slidesToShow: 1,
		      },
		    },
    ],
  })

  $('.js-slider-solutions .slider__slides').on('afterChange', function (event, { slideCount: count }, currentSlide, nextSlide){
    $('.media[data-media-index="' + (currentSlide+1) + '"]').addClass('is-visible').siblings().removeClass('is-visible')
  })
}

$(window).on('load', function () {
  initSlickSlider()
})
